import React from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import dayjs from 'dayjs';

import { Ticket } from '@totem/components/ticketing/ticketing';
import TagDisplay, {
  OPPORTUNITY_STATUS_STYLES,
  TICKET_STATUS_STYLES,
  TICKET_SUB_STATUS_STYLES,
} from '@totem/components/ui_components/widgets/tagDisplay/tagDisplay';
import { formatDateOnly } from '@totem/utilities/common';

type Props = {
  ticket: Ticket;
};

const StatusDisplayExtended = ({ ticket }: Props) => {
  if (!ticket || !ticket.status) {
    return null;
  }

  const isDeferred =
    ticket.status === 'OPEN' &&
    ticket.followUpAt !== null &&
    ticket.followUpAt !== '' &&
    dayjs(ticket.followUpAt).isAfter(dayjs());

  const deferredStyle = OPPORTUNITY_STATUS_STYLES.Deferred;

  return (
    <Space size="small">
      {isDeferred ? (
        <Space direction="vertical" size={2}>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              padding: '2px 8px',
              borderRadius: 4,
              fontSize: 11,
              fontWeight: 700,
              background: deferredStyle.bg,
              color: deferredStyle.color,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              whiteSpace: 'nowrap',
            }}
          >
            <ClockCircleOutlined />
            Deferred
          </span>
          <span style={{ color: deferredStyle.color, fontSize: 12 }}>
            until {formatDateOnly(ticket.followUpAt)}
          </span>
        </Space>
      ) : (
        <TagDisplay value={ticket.status} config={TICKET_STATUS_STYLES} />
      )}
      {ticket.subStatus && ticket.subStatus !== '' && (
        <TagDisplay
          value={ticket.subStatus}
          config={TICKET_SUB_STATUS_STYLES}
        />
      )}
    </Space>
  );
};

export default StatusDisplayExtended;
